import { RELATORIOS_ENUM } from './reports-enums';

import { vehicleAnalyticReportInitialValues } from '../forms/vehicle/analytic/vehicle-analytic-initial-values';
import { vehicleSyntheticReportInitialValues } from '../forms/vehicle/synthetic/vehicle-synthetic-initial-values';
import { licenseReportInitialValues } from '../forms/license/license-initial-values';
import {
  companiesReportInitialValues,
  companySituationReportInitialValues,
} from '../forms/companies/companies-initial-values';
import { inspectionReportInitialValues } from '../forms/inspection/inspection-initial-values';
import { slicLinesReportInitialValue, stripLinesReportInitialValue } from '../forms/lines/line-initial-values';
import { permissionaryInitialValues } from '../forms/permissionaries/permissionary-initial-values';
import { documentReportInitialValues } from '../forms/documents/document-initial-values';
import { stripContractReportInitialValues } from '../forms/contract/contract-initial-values';

import VehicleAnalyticReport from '../forms/vehicle/analytic/VehicleAnalyticReport';
import VehicleSyntheticReport from "../forms/vehicle/synthetic/VehicleSyntheticReport";
import LicenseReport from '../forms/license/LicenseReport';
import RequestsReport from '../forms/requests/RequestsReport';
import CompaniesReport from '../forms/companies/CompaniesReport';
import InspectionReport from '../forms/inspection/InspectionReport';
import SlicLinesReport from '../forms/lines/SlicLinesReport';
import PermissionariesReport from '../forms/permissionaries/PermissionariesReport';
import StripLinesReport from '../forms/lines/StripLinesReport';
import StripContractReport from '../forms/contract/StripContractReport';
import DocumentReport from '../forms/documents/DocumentReport';
import { requestsReportInitialValues } from '../forms/requests/requests-initial-values';
import CompanySituationReport from '../forms/companies/CompanySituationReport';

export const REPORT_MAP = {
  [RELATORIOS_ENUM.VEICULOS_FROTAS_ANALITICO]: {
    title: 'Relatório de frotas - Analítico',
    fileName: 'Relatório de frota de veículos - Analítico',
    formInitials: vehicleAnalyticReportInitialValues,
    Component: VehicleAnalyticReport,
  },
  [RELATORIOS_ENUM.VEICULOS_FROTAS_SINTETICO]: {
    title: 'Relatório de frotas - Sintético',
    fileName: 'Relatório de frota de veículos - Sintético',
    formInitials: vehicleSyntheticReportInitialValues,
    Component: VehicleSyntheticReport,
  },
  [RELATORIOS_ENUM.VISTORIAS]: {
    title: 'Relatório de vistorias',
    fileName: 'Relatório de Vistorias',
    formInitials: inspectionReportInitialValues,
    Component: InspectionReport,
  },
  [RELATORIOS_ENUM.SLIC_LINHAS]: {
    title: 'Relação de Linhas Complementares por Pólo',
    fileName: 'Relação de Linhas Complementares por Pólo',
    formInitials: slicLinesReportInitialValue,
    Component: SlicLinesReport,
  },
  [RELATORIOS_ENUM.SLIC_PERMISSIONARIOS]: {
    title: 'Permissionários',
    fileName: 'Relatório de Permissionários - Linha Complementar',
    formInitials: permissionaryInitialValues,
    Component: PermissionariesReport,
  },
  [RELATORIOS_ENUM.STRIP_LINHAS]: {
    title: 'Linhas - STRIP',
    fileName: 'Relatório Geral de Linhas',
    formInitials: stripLinesReportInitialValue,
    Component: StripLinesReport,
  },
  [RELATORIOS_ENUM.STRIP_CONTRATOS]: {
    title: 'Contratos - STRIP',
    fileName: 'Relatório de Contratos',
    formInitials: stripContractReportInitialValues,
    Component: StripContractReport,
  },
  [RELATORIOS_ENUM.STRIP_CONTRATOS_DOCUMENTOS]: {
    title: 'Relação de documentos de linha',
    fileName: 'Relação de documentos de linha',
    formInitials: documentReportInitialValues,
    Component: DocumentReport,
  },
  [RELATORIOS_ENUM.EMPRESAS]: {
    title: 'Relatório de Registros Cadastrais',
    fileName: 'Relatório de Registros Cadastrais',
    formInitials: companiesReportInitialValues,
    Component: CompaniesReport,
  },
  [RELATORIOS_ENUM.LICENCAS]: {
    title: 'Licenças',
    fileName: 'Relatório de Licenças',
    formInitials: licenseReportInitialValues,
    Component: LicenseReport,
  },
  [RELATORIOS_ENUM.SOLICITACOES]: {
    title: 'Solicitações',
    fileName: 'Relatório de Solicitações',
    formInitials: requestsReportInitialValues,
    Component: RequestsReport,
  },
  [RELATORIOS_ENUM.EMPRESAS_SITUACAO]: {
    title: 'Relatório de Situação Cadastral',
    fileName: 'Relatório de Situação Cadastral',
    formInitials: companySituationReportInitialValues,
    Component: CompanySituationReport,
  }
};

